import util from '@bmp-vue/core/api/util'

const controller = 'Arquivaria';
export default Object.assign({}, util.GetCrud(controller, ['getall']), {});  
